//export const API_URL="https://elevatetabletapi-staging.azurewebsites.net/"
//export const API_URL=""

//Local Development
//export const API_URL="https://localhost:44381/"
//export const SignalR_URL="http://localhost:7068/api"

//Staging
//export const API_URL="https://elevatetabletapi-staging.azurewebsites.net/"
//export const SignalR_URL="https://elevatesignalr-staging.azurewebsites.net/api"

//Production
export const API_URL="https://elevatetablet-api.azurewebsites.net/"
export const SignalR_URL="https://elevatesignalr.azurewebsites.net/api"

